import styled from "styled-components";

export const Wrapper = styled.div`
  padding: 16px;

  border-radius: ${(props) => props.theme.borderRadius.small}px;
  background: ${(props) => props.theme.colors.uiBackground};
  box-shadow: ${(props) => props.theme.shadows.regular};
`;

export const Inner = styled.div`
  position: relative;

  display: flex;
  gap: 8px;
  align-items: center;
`;

export const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 9999px;
  background-color: ${(props) => props.theme.colors.tertiary}20;
`;

export const Main = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const TagWrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
`;

export const Tag = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 4px 6px;
  min-height: 24px;

  background: ${(props) => props.theme.colors.tertiary}11;
  box-shadow: 0 0 0 1px ${(props) => props.theme.colors.tertiary}44;
  color: ${(props) => props.theme.colors.primary};
  border-radius: ${(props) => props.theme.borderRadius.micro}px;

  svg {
    &:last-child {
      margin-right: -1px;
    }

    * {
      stroke-width: 10px;
      stroke: currentColor;
    }
  }
`;
